"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1166,1917],{

/***/ 68019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var nolazy = _ref.nolazy,
      visible = _ref.visible,
      srcSm = _ref.srcSm,
      src = _ref.src,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  var DefaultBanner = '/images/static/blurbg.svg';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      deviceWidth = _useState[0],
      setDeviceWidth = _useState[1]; // set device width


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener('resize', HandleWidth);
    HandleWidth();
    return function () {
      window.removeEventListener('resize', HandleWidth);
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image",
    srcSm: srcSm,
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      alt: alt || 'Shanta Securities Limited',
      objectFit: 'cover',
      layout: 'fill',
      src: src ? deviceWidth > 600 ? src : srcSm ? srcSm : src : DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Img__StyledImg",
  componentId: "sc-1091rec-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";img{width:100%;height:100%;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 35196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68312);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68019);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30653);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93264);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);












var MyComponent = function MyComponent(_ref) {
  var _section_image$list, _section_image$list$, _section_image$list2, _section_image$list2$, _section_image$list3, _section_image$list3$;

  var data = _ref.data;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  var section_image = data === null || data === void 0 ? void 0 : data.images;
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap__WEBPACK_IMPORTED_MODULE_6__/* .gsap.to */ .p8.to('.hide', {
      alpha: 1,
      visibility: 'visible',
      display: 'block',
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname]); // Run this effect only once when the component mounts

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledComponent, {
    className: 'who-is  pt-200 pb-200',
    children: [(section_image === null || section_image === void 0 ? void 0 : (_section_image$list = section_image.list) === null || _section_image$list === void 0 ? void 0 : (_section_image$list$ = _section_image$list[0]) === null || _section_image$list$ === void 0 ? void 0 : _section_image$list$.full_path) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_1__/* .Img */ .E, {
      alt: 'Shanta Securities Limited',
      src: section_image !== null && section_image !== void 0 && (_section_image$list2 = section_image.list) !== null && _section_image$list2 !== void 0 && (_section_image$list2$ = _section_image$list2[0]) !== null && _section_image$list2$ !== void 0 && _section_image$list2$.full_path ? section_image === null || section_image === void 0 ? void 0 : (_section_image$list3 = section_image.list) === null || _section_image$list3 === void 0 ? void 0 : (_section_image$list3$ = _section_image$list3[0]) === null || _section_image$list3$ === void 0 ? void 0 : _section_image$list3$.full_path : 'images/dynamic/20849.jpg'
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          sm: 2,
          children: [(section_data === null || section_data === void 0 ? void 0 : section_data.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
            "data-lag": "0.3",
            className: 'desktop  ',
            children: section_data === null || section_data === void 0 ? void 0 : section_data.title
          }), (section_data === null || section_data === void 0 ? void 0 : section_data.short_desc) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h4", {
            "data-lag": "0.8",
            className: 'desktop ',
            children: section_data === null || section_data === void 0 ? void 0 : section_data.short_desc
          }), (section_data === null || section_data === void 0 ? void 0 : section_data.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
            className: 'mobile',
            children: section_data === null || section_data === void 0 ? void 0 : section_data.title
          }), (section_data === null || section_data === void 0 ? void 0 : section_data.short_desc) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h4", {
            className: 'mobile',
            children: section_data === null || section_data === void 0 ? void 0 : section_data.short_desc
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          className: 'side-content',
          sm: 10,
          children: (section_data === null || section_data === void 0 ? void 0 : section_data.description) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.description)
        })]
      })
    })]
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "WhoIs__StyledComponent",
  componentId: "sc-nnx2oi-0"
})(["position:relative;background-color:", ";min-height:100vh;display:flex;align-items:center;.col-sm-2{position:relative;}h3{font-size:60px;line-height:60px;color:#3C3C3B;white-space:nowrap;font-family:\"Avenir Heavy\";@media(max-width:767px){font-size:35px;line-height:45px;}&.desktop{transform:rotate(-90deg);position:absolute;top:40%;left:-72%;@media (min-width:1599px){left:-44%;}@media (max-width:991px){left:-110%;}@media (max-width:800px){left:-140%;}}}h4{font-size:60px;line-height:60px;color:#3C3C3B;white-space:nowrap;font-family:\"Avenir Heavy\";@media(max-width:767px){font-size:35px;line-height:45px;}&.desktop{transform:rotate(-90deg);position:absolute;top:60%;left:-36%;@media (min-width:1599px){left:-25%;}@media (max-width:991px){left:-68%;}@media (max-width:800px){left:-92%;}}}.side-content{h4{font-family:", ";font-size:24px;font-weight:500;line-height:36px;color:#3C3C3B;margin-bottom:35px;white-space:normal;}p{font-size:16px;line-height:24px;color:#3C3C3B;font-weight:500;&:not(:nth-last-child(1)){margin-bottom:30px;}}}@media (min-width:768px){.mobile{display:none;}}@media(max-width:992px){}@media (max-width:767px){.col-sm-2,.col-sm-10{min-width:100%;}h4{&.mobile{margin-bottom:40px;}}h3{transform:none;margin-bottom:0px;white-space:break-spaces;}.desktop{display:none;}p{font-size:28px;line-height:32px;}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .text */ .fL, _Title__WEBPACK_IMPORTED_MODULE_3__["default"]);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(MyComponent));

/***/ })

}]);